
  import ipxRuntime$Sx3SKjEyP0CHJT_45QJSLkrK2WaoreaTvB_c3MlS3TkUY from '/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_ioredis@5.11.1_magicast@0.5.3/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$Sx3SKjEyP0CHJT_45QJSLkrK2WaoreaTvB_c3MlS3TkUY, defaults: {} }
    }
  }
